import useDotLottie from '../hooks/useDotLottie';

import CommonImages from './index';

const AnimatedLogo = CommonImages.ECAL_LOADING_LOTTIE;

const EcalLogo = ({ ...props }) => {
    const { canvasRef } = useDotLottie({ src: AnimatedLogo });

    return <canvas ref={canvasRef} aria-label="loading" style={{ width: 260, height: 100, maxWidth: '100%' }} {...props} />;
};

export default EcalLogo;